import Editor from './Editor';
import createTaskType from '../../createTaskType';
import { times } from "lodash";

export default createTaskType({
    // Backend uses factual topic instead because of the similarities
    id: 'factual_topic',
    label: 'Gap-fill Story',
    skill: 'reading_writing',
    v2: true,
    hasRubric: true,
    rubric: {    convertToLocalFormat(task) {
        task.items = task.items.map((item, index) => {
            item.index = index;
            const pageParts = item.page?.split('PAGE_') ?? [];
            item.page = pageParts.length === 2 ? parseInt(pageParts[1]) : null;
            return item;
        })
        return task;
    },
        phaseCount: 2
    },
    backgroundImages: {
        count: 1,
        configs: [
            {
                label: 'Background Image'
            }]
    },

    editor: Editor,
    createItemsTemplate: () => [
        ...times(7, createPhase1Item),
        createPhase2Item({ index: 7 })
    ],
    convertToLocalFormat(task) {
        task.items = task.items.map((item, index) => {
            item.index = index;
            const pageParts = item.page?.split('PAGE_') ?? [];
            item.page = pageParts.length === 2 ? parseInt(pageParts[1]) : null;
            return item;
        })
        return task;
    },
    convertToUploadFormat(task) {

        task.items = task.items.map(item => {
            delete item.index;
            item.page = !!item.page ? `PAGE_${item.page}` : null;
            // Fix an issue created by tasks which were created with the PHASE_2 item being an example
            if (item.phase === 'PHASE_2') {
                item.is_example = false;
                item.stimulus_text = null;
            }
            return item;
        })
        return task;
    },

    getKeys: (item) => {
        const correct_answer = item.answers.find(x => x.is_correct_answer);
        return [correct_answer.text];
    }
});

const DEFAULT_ORDER = [[1, 2], [3], [4, 5], [6, 7], [8, 9], [10, 11], [12, 13]];

function createPhase1Item(index) {
    const is_example = index === 0;
    const page = Math.floor(Math.max(index - 1, 0) / 2) + 1;
    return {
        phase: 'PHASE_1',
        index,
        page,
        is_example,
        ...(is_example && { rubric_id: '' }),
        stimulus_text: '',
        // page !== 1 || is_example ? 2 : 1
        answers: times(DEFAULT_ORDER[index].length, (i) => ({
            is_correct_answer: i === 0,
            text: '',
            display_order: DEFAULT_ORDER[index][i]
        }))
    }
}


function createPhase2Item({ index } = {}) {
    return {
        index,
        is_example: false,
        phase: 'PHASE_2',
        rubric_id: '',
        stimulus_text: null,
        answers: times(3, (i) => ({
            is_correct_answer: i === 0,
            text: '',
            display_order: i + 1
        }))
    }
}